import { createSlice } from '@reduxjs/toolkit'
import { AppConfig } from './types'

type AppConfigState = {
  config: AppConfig | null
}

const initialState: AppConfigState = {
  config: null,
}

export const appConfigSlice = createSlice({
  name: 'app-config',
  initialState,
  reducers: {
    setAppConfig(state, action: { payload: AppConfig }) {
      state.config = action.payload
    },
  },
})

export const AppConfigActions = {
  ...appConfigSlice.actions,
}

export const AppConfigReducer = appConfigSlice.reducer
